import { render, staticRenderFns } from "./DashboardAttendanceOverview.vue?vue&type=template&id=553b4507&"
import script from "./DashboardAttendanceOverview.vue?vue&type=script&lang=js&"
export * from "./DashboardAttendanceOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports